// extracted by mini-css-extract-plugin
export default {"languages":"Gt7hs","header":"SRdqy","languages__item":"ptInW"};